import { createReducer, on } from '@ngrx/store';
import {
    determineNativePlatformSuccess,
    determinePlatformSuccess,
    loadNotificationsChannels,
    pushNotificationListenersAdded,
    pushNotificationListenersRemoved,
    pushNotificationTokenReceived,
    updateNotificationsChannelsSuccess
} from './permissions.actions';
import { NotificationChannel, Platform } from '@ridango/core';

export interface PermissionsState {
    platform: Platform;
    pushNotificationToken: string | null;
    isNativeApp: boolean;
    channels: null | NotificationChannel;
    listenersAdded: boolean;
}

export const PERMISSIONS_FEATURE_KEY = 'Permissions';

export const permissionsInitialState: PermissionsState = {
    platform: null,
    pushNotificationToken: null,
    isNativeApp: null,
    channels: null,
    listenersAdded: false
};

export const permissionsReducer = createReducer(
    permissionsInitialState,
    on(determinePlatformSuccess, (state, { platform }) => ({ ...state, platform })),
    on(determineNativePlatformSuccess, (state) => ({ ...state, isNativeApp: true })),
    on(pushNotificationTokenReceived, (state, { token }) => ({ ...state, pushNotificationToken: token })),
    on(pushNotificationListenersAdded, (state) => ({ ...state, listenersAdded: true })),
    on(pushNotificationListenersRemoved, (state) => ({ ...state, listenersAdded: false })),
    on(updateNotificationsChannelsSuccess, (state, { channels }) => ({ ...state, channels })),
    on(loadNotificationsChannels, (state, { channels }) => ({ ...state, channels }))
);
